/**
 * Customer service pop-down in the header.
 * Click to toggle; Escape or an outside click closes it.
 */
(() => {
  const init = () => {
    document.querySelectorAll('.fw-support').forEach((root) => {
      if (root.dataset.fwSupportReady === 'true') return;
      root.dataset.fwSupportReady = 'true';

      const trigger = root.querySelector('.fw-support__trigger');
      const panel = root.querySelector('.fw-support__panel');
      if (!trigger || !panel) return;

      const setOpen = (open) => {
        panel.hidden = !open;
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      };

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        setOpen(panel.hidden);
      });

      document.addEventListener('click', (event) => {
        if (!root.contains(event.target)) setOpen(false);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') setOpen(false);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
